<template>
    <div class="packages-channel-body" v-show="isShow">
        <div class="packages-channel-title">
            <div class="packages-title">
                {{ packages[className].title }}
            </div>
            <div class="close" @click="isShow = false">
                <close-outlined></close-outlined>
            </div>
            <div class="packages-name">
                {{ packages[className].name }}
            </div>
        </div>
        
        <div class="packages-channel-inset">
            <div class="packages-channel-list">
                <div 
                    class="packages-channel" 
                    v-for="(n, index) in packages[className].channelList" 
                    :key="index">
                    <div class="channel-name">
                        {{ n.name }}<label>{{ n.num }}ch</label>
                        <div class="open-btn" @click="n.isShow = !n.isShow">
                            <caretUpFilled v-if="n.isShow"></caretUpFilled>
                            <caretDownFilled v-else ></caretDownFilled>
                        </div>
                    </div>
                    <div class="channel-list" v-if="n.isShow">
                        <div class="channel" v-for="c in n.list" :key="c">
                            {{ c }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import packages from '../../../js/packages'
export default {
    data () {
        return {
            isShow: false,
            className: 'A',
            packages
        }
    },
    methods: {
        init (className = 'A') {
            this.isShow = true
            this.className = className
        }
    }
}
</script>
<style scoped>
.packages-channel-body {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: #F5F6F7;
    z-index: 1000;
    box-sizing: border-box;
    padding: 10px;
    padding-top: 70px;
}
.packages-channel-title {
    text-align: center;
    height: 60px;
    position: absolute;
    top:10px;
    left: 0;
    width: 100%;
}
.packages-title {
    font-size: 24px;
    font-family: A-OTF Gothic MB101 Pr5;
    font-weight: bold;
    color: #000000;
    height: 40px;
    line-height: 40px;
}
.packages-name {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #000000;
    height: 20px;
    line-height: 20px;
}
.close {
    width: 30px;
    height: 30px;
    position: absolute;
    top: 0px;
    right: 10px;
    line-height: 30px;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
}
.packages-channel-inset {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 10px;
    padding-top: 20px;
}
.packages-channel-list {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
}
.packages-channel {
    border-radius: 10px;
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
    /* padding: 10px; */
    background: #fff;
    margin-bottom: 20px;
}
.channel-name {
    padding: 10px;
    width: 100%;
    box-sizing: border-box;
    background: #FDB819;
    color:#fff;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    position: relative;
}
.channel-name label {
    font-weight: normal;
    position: absolute;
    right: 50px;
    top: 10px;
}
.open-btn {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
}
.channel-list {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 24px;
}
</style>